import ScrollReveal from '../shared/ScrollReveal'
import GradientText from '../shared/GradientText'
import './VideoSection.css'

export default function VideoSection() {
  return (
    <section className="video-section" id="video">
      <div className="container">
        <ScrollReveal className="video-header">
          <span className="video-badge">// PLATFORM IN MOTION</span>
          <h2 className="video-title">
            See AI4Solar{' '}
            <GradientText gradient="energy">in 2 minutes 50.</GradientText>
          </h2>
          <p className="video-subtitle">
            From ground sensor to satellite orbit — multi-modal predictive intelligence for solar farms.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.15}>
          <div className="video-frame">
            <div className="video-embed">
              <iframe
                src="https://www.youtube-nocookie.com/embed/KwCz7XeF2So?rel=0&modestbranding=1"
                title="AI4Solar — Multi-modal predictive intelligence for solar farms"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
}
